export default "__VITE_ASSET__Bqnp0jhx__"